export const getRandomColor = () => {
    return  "hsl(" + Math.random() * 360 + ", 100%, 75%)";
};